import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

interface IProps {
  id: string;
  page?: number;
  limit?: number;
}

export const useGetKeyHostKeys = ({
  id,
  page = 1,
  limit = 10,
}: IProps): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.GET_KEY_HOST_KEYS, { id, page, limit }],
    {
      enabled: !!id,
      retry: false,
      refetchOnWindowFocus: false,
      notifyOnChangeProps: [
        "data",
        "error",
        "refetch",
        "isRefetching",
        "isSuccess",
        "isLoading",
      ],
    }
  );
};
